<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            ref="grid"
            :expandedOptions="{
                enabled: true,
                getTemplateName: getTemplateName,
            }"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Covid Screening Logs",
        columns: [
            {
                field: "passed",
                isIcon: true,
                type: "boolean",
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, data) => {
                    return value === true ? "mdi-check-circle" : "mdi-flag";
                },
                iconColor: (value, data) => {
                    return value === true ? "success" : "#f35123";
                },
            },
            {
                field: "studentID",
                label: "Student ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Family ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "For Date",
                field: "forDate",
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Caller ID",
                field: "callerID",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Passed",
                field: "passed",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Symptoms",
                field: "symptoms",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Tested Positive",
                field: "testedPositive",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Traveled Abroad",
                field: "traveledAbroad",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Came In Contact",
                field: "cameInContact",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Updated",
                field: "lastUpdated",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
        ],

        actions: [],
        url: "",
    }),
    created() {},
    methods: {
        async beforeSetupGrid() {
            this.url = "covidScreening";
        },
        getTemplateName(data) {
            if (data.source == "IVR") {
                return "screening-ivr-call-details";
            }

            return "covid-screening-sms-messages";
        },
    },
};
</script>
<style></style>
